import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function SubscriptionCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center animate-fade-in-up">
        <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl">🤔</span>
        </div>
        <h1 className="font-['Playfair_Display'] text-2xl font-bold text-slate-900 mb-2">
          Pago cancelado
        </h1>
        <p className="text-slate-600 mb-8">
          Has cancelado el proceso de pago. Puedes continuar usando la versión gratuita o intentarlo más tarde.
        </p>
        <div className="space-y-3">
          <Button
            onClick={() => navigate('/subscription')}
            className="w-full bg-amber-500 hover:bg-amber-400 text-slate-900 rounded-full py-6"
            data-testid="try-again-btn"
          >
            Ver planes Premium
          </Button>
          <Button
            onClick={() => navigate('/dashboard')}
            variant="outline"
            className="w-full rounded-full py-6"
            data-testid="go-dashboard-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver al Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
